import React, { useState } from 'react';
import './Enroll.css';
import { Button, Container, Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Enroll = () => {
    const { name } = useParams();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <Container >
            <div className='footer-design'>
                <h2>Registration for <span className='text-primary '> {name}</span></h2>
                <form className='registration-form'>
                    <p>First Name: <input type="text" placeholder='your first name' required /></p>
                    <p>Last Name: <input type="text" placeholder='your last name' required /></p>
                    <p>Father's Name: <input type="text" placeholder='your father name' required /></p>
                    <p>Mother's Name: <input type="text" placeholder='your mother name' required /></p>
                    <p> Email: <input type="email" name="" id="" placeholder='your email' required /></p>
                    <p>Date of Birth: <input type="datetime" name="" id="" /></p>
                    <p>Phone Number: <input type="number" name="" id="" placeholder='your phone number' required /></p>
                    <p> Address: <input type="text" name="" id="" placeholder='your address' /></p>

                    <textarea placeholder='Write your comments here' name="" id="" cols="100" rows="10"></textarea>
                    <br />

                    <>
                        <Button variant="primary" onClick={handleShow}>
                            <Link> <a className='text-white' href="">Submit</a></Link>
                        </Button>

                        <Modal
                            show={show}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={false}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Congratulations!!!</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                You are successfully enrolled
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                </form>
            </div>
        </Container>
    );
};

export default Enroll;